import {
  isEmail,
  isMobilePhone,
  isDate,
  isDecimal,
  isNumeric
} from 'validator';
import { STATUSES_POSITIVE } from './contacts';

const PATTERN_IBAN = /[a-z]/i;
const PATTERN_BIC_CODE = /[a-z]/i;

const isIban = str => PATTERN_IBAN.test(str);
const isBicCode = str => PATTERN_BIC_CODE.test(str);

export const VALIDATOR_KEY_EMAIL = 'email';
export const VALIDATOR_KEY_PHONE = 'phone';
export const VALIDATOR_KEY_DATE = 'date';
export const VALIDATOR_KEY_DATETIME = 'datetime';
export const VALIDATOR_KEY_MONEY = 'money';
export const VALIDATOR_KEY_NUMBER = 'number';
export const VALIDATOR_KEY_IBAN = 'iban';
export const VALIDATOR_KEY_BIC_CODE = 'bic_code';
export const VALIDATOR_REQUIRED_IF_POSITIVE = 'required_if_positive';

export const VALIDATORS_LABELS = {
  [VALIDATOR_KEY_EMAIL]: VALIDATOR_KEY_EMAIL,
  [VALIDATOR_KEY_PHONE]: VALIDATOR_KEY_PHONE,
  [VALIDATOR_KEY_DATE]: VALIDATOR_KEY_DATE,
  [VALIDATOR_KEY_DATETIME]: VALIDATOR_KEY_DATETIME,
  [VALIDATOR_KEY_MONEY]: VALIDATOR_KEY_MONEY,
  [VALIDATOR_KEY_NUMBER]: VALIDATOR_KEY_NUMBER,
  [VALIDATOR_KEY_IBAN]: VALIDATOR_KEY_IBAN,
  [VALIDATOR_KEY_BIC_CODE]: VALIDATOR_KEY_BIC_CODE,
  [VALIDATOR_REQUIRED_IF_POSITIVE]: VALIDATOR_REQUIRED_IF_POSITIVE
};

const stringifyParam = func => param => func(param + '');

const requiredIfPositive = (value, formData) => {
  if (STATUSES_POSITIVE.indexOf(formData.call.status) >= 0) {
    if (!value) {
      return;
    }
  }
  return true;
};

export const VALIDATORS = {
  [VALIDATOR_KEY_EMAIL]: stringifyParam(isEmail),
  [VALIDATOR_KEY_PHONE]: stringifyParam(isMobilePhone),
  [VALIDATOR_KEY_DATE]: stringifyParam(isDate),
  [VALIDATOR_KEY_DATETIME]: stringifyParam(isDate),
  [VALIDATOR_KEY_MONEY]: stringifyParam(isDecimal),
  [VALIDATOR_KEY_NUMBER]: stringifyParam(isNumeric),
  [VALIDATOR_KEY_IBAN]: isIban,
  [VALIDATOR_KEY_BIC_CODE]: isBicCode,
  [VALIDATOR_REQUIRED_IF_POSITIVE]: requiredIfPositive
};

export const VALIDATOR_OPTIONS = Object.keys(VALIDATORS);



// WEBPACK FOOTER //
// ./src/helpers/validators.js